{
	"common": {
		"save": "Lagre",
		"skip": "Hopp over",
		"back": "Tilbake",
		"cancel": "Avbryt",
		"create-new": "Lag ny",
		"and-others_one": "og {{count}} annen",
		"and-others_other": "og {{count}} andre"
	},
	"settings": "Innstillinger",
	"my-organisations": "Mine organisasjoner",
	"my-role": "Min rolle:",
	"organisation-not-found": "Finner ikke organisasjonen",
	"tab-label-caregivers": "Omsorgspersoner",
	"tab-label-care-recipients": "Omsorgsmottakere",
	"tab-label-archived": "Arkivert",
	"tab-label-temporary-access": "Midlertidig tilgang",
	"toasts": {
		"success": {
			"role-updated": "Rollen er oppdatert",
			"member-archived": "Bruker arkivert",
			"caregivers-assigned": "Omsorgspersoner er tildelt",
			"care-recipient-created": "Omsorgsmottaker er opprettet",
			"employee-created": "Ansatt er opprettet",
			"profile-saved": "Profilen er lagret",
			"reset-password-mail-sent": "Tilbakestill passord-lenke sendt med e-post",
			"team-created": "Teamet er opprettet",
			"teams-assigned": "Lag er tildelt",
			"members-added-to-team": "Medlemmer er lagt til laget",
			"member-removed-from-team": "Medlemmet er fjernet fra laget",
			"team-updated": "Teamet er oppdatert",
			"invitation-accept-title": "Akseptert",
			"invitation-accept-content": "Godkjent tilkoblingsforespørselen",
			"invitation-reject-title": "Avvist",
			"invitation-reject-content": "Du har avvist tilkoblingsforespørselen",
			"organization-updated": "Organisasjonen er oppdatert",
			"temporary-access-invite-sent": "Midlertidig tilgangsinvitasjon er sendt",
			"temporary-access-revoked": "Midlertidig tilgang er tilbakekalt",
			"member-restored": "Medlem gjenopprettet",
			"family-caregiver-disconnected": "Familieomsorgsperson er koblet fra"
		},
		"error": {
			"something-wrong": "Noe gikk galt",
			"no-care-recipients-selected": "Ingen omsorgsmottakere er valgt"
		}
	},
	"table": {
		"header": {
			"username": "Brukernavn",
			"role": "Rolle",
			"email": "E-post",
			"name": "Navn",
			"requester": "Avsender",
			"care-recipient": "Omsorgsmottaker",
			"access-end-date": "Sluttdato for tilgang"
		},
		"actions": {
			"edit": "Redigere",
			"archive": "Arkiv",
			"unarchive": "Avarkiver",
			"assign-caregiver": "Tildel omsorgsperson",
			"reset-password": "Tilbakestille passord",
			"assign-to-teams": "Tilordne til team",
			"remove-from-team": "Fjern fra teamet",
			"invite-family-member": "Inviter familiemedlem",
			"view-profile": "Vis profil",
			"accept": "Aksepterer",
			"reject": "Avvis",
			"temporary-access": "Midlertidig tilgang",
			"revoke-access": "Oppheve tilgang",
			"deny-pletly-access": "Ikke gi Pletly tilgang"
		}
	},
	"new-employee": "Ny ansatt",
	"assign": "Tilpass",
	"assign-caregivers-to": "Tildel omsorgspersoner til {{name}}",
	"inputs": {
		"organization-name": "Organisasjonsnavn"
	},
	"create-account-for-employee": "Opprett konto for ansatt",
	"create-account-for-care-recipient": "Opprett konto for omsorgsmottaker",
	"care-recipient-created-confirmation": {
		"subtitle": "Ønsker du å gi flere detaljer om omsorgsmottakeren din for å hjelpe andre omsorgspersoner bedre å forstå deres behov?",
		"secondaryButton": "Tildel omsorgspersoner",
		"ctaButton": "Legg til informasjon",
		"title": "Du har opprettet en konto for {{name}}"
	},
	"fill-care-recipient-information": {
		"title": "Legg til informasjon om Omsorgsmottaker"
	},
	"fill-information-confirmation": {
		"title": "Takk skal du ha!\nYtterligere informasjon er alltid nyttig!",
		"ctaButton": "Tildel omsorgspersoner",
		"subtitle": "Du kan tilordne omsorgspersoner til {{name}}"
	},
	"teams": {
		"new-team": "Nytt Team",
		"form": {
			"label-name": "Navn på Team",
			"label-posts-screening": "Innlegg screening",
			"post-screening-disabled-info": "Det kreves minst én teamadministrator for å endre denne innstillingen"
		},
		"teams": "Teams",
		"team-not-found": "Team ble ikke funnet",
		"no-teams-yet": "Ingen team er opprettet ennå.",
		"edit-team": "Rediger team",
		"other-teams": "Andre teams",
		"no-other-teams-created": "Ingen andre team er opprettet.",
		"new-sub-team": "Underteam",
		"delete": {
			"are-you-sure-you-want-to-delete-the-name-team": "Er du sikker på at du vil slette {{ name }} teamet?",
			"team-deleted": "Team slettet",
			"this-will-also-remove-its-sub-teams-if-any": "Dette vil også fjerne de nestede lagene.",
			"delete-team": "Slett team",
			"if-you-want-also-to-disconnect-caregivers-or-care-recipients-inside-team-please-do-so-first": "Hvis du også vil koble fra omsorgspersoner eller mottakere av omsorg i teamet, kan du gjøre det først.",
			"label-description": "Denne handlingen vil slette teamet, og den kan ikke angre."
		},
		"help-content": "Teams i Pletly gjør det enklere å administrere tilganger. Når du legger til en omsorgsperson i et team, får vedkommende automatisk tilgang til alle omsorgsmottakere i teamet. Legger du til en ny omsorgsmottaker i teamet, får alle omsorgspersonene tilgang. Fjerner du noen fra teamet, fjernes tilgangen samtidig.\n\nDu kan også opprette underteam. Omsorgspersoner i hovedteamet vil fortsatt ha tilgang til omsorgsmottakere i underteam, selv om de ikke er lagt direkte til der."
	},
	"assign-to-teams": "Tilordne til team",
	"add-caregivers-to-team": "Legg Omsorgspersoner til teamet",
	"add-care-recipients-to-team": "Legg til omsorgsmottakere i teamet",
	"no-members-to-add": "Ingen medlemmer å legge til",
	"confirmations": {
		"remove-from-team": {
			"title": "Vil du fjerne {{name}} fra teamet?",
			"content-caregiver": "Å fjerne en omsorgsperson fra et team vil koble dem fra alle omsorgsmottakere som tilhører det teamet.",
			"content-care-recipient": "Å fjerne en omsorgsmottaker fra et team vil koble dem fra alle omsorgspersoner som tilhører det teamet."
		},
		"accept-invitation": {
			"title": "Godta forespørsel om tilkobling?",
			"content": "Er du sikker på at du vil godta {{requesterName}}s forespørsel om å bli omsorgsperson for {{careRecipientName}}?"
		},
		"reject-invitation": {
			"title": "Vil du avvise forespørsel om tilkobling?",
			"content": "Er du sikker på at du vil avvise {{requesterName}}s forespørsel om å bli omsorgsperson for {{careRecipientName}}?"
		},
		"revoke-temporary-access": {
			"title": "Oppheve midlertidig tilgang?",
			"content": "Er du sikker på at du vil tilbakekalle {{caregiverEmail}} sin midlertidige tilgang til {{careRecipientName}} sin profil?"
		},
		"archive-organisation-member": {
			"title": "Arkivbruker",
			"content": "Er du sikker på at du vil arkivere {{name}}?"
		},
		"block-organisation-member-login": {
			"title": "Ikke tillat bruker å bruke Pletly",
			"content": "Tilgang kan slås på senere ved å angi et nytt passord. \n\n \nEr du sikker på at du vil blokkere pålogging for {{name}}?"
		},
		"unarchive-organisation-member": {
			"content": "Er du sikker på at du vil gjenopprette {{name}} sin konto?",
			"title": "Gjenopprett bruker"
		}
	},
	"tab-label-familycaregivers": "Familieomsorgspersoner",
	"terms-of-use": {
		"title": "Vilkår for bruk",
		"manage-terms-of-use": "Administrer vilkårene for bruk",
		"new-version": "Ny verson",
		"table": {
			"updated-at": "Oppdatert kl",
			"members-accepted": "Medlemmer godtatt",
			"text": "Tekst"
		},
		"accepted": "Akseptert",
		"terms-of-use-accepted": "Vilkår for bruk akseptert",
		"i-agree-to-the-terms-of-use-as-outlined-by": "Jeg godtar vilkårene for bruk som beskrevet av",
		"members-who-accepted": "Medlemmer som takket ja",
		"new-terms-of-use": "Nye vilkår for bruk",
		"new-terms-of-use-field-placeholder": "Vilkår for bruk",
		"terms-of-use-created": "Vilkår for bruk opprettet",
		"accept": "Aksepterer"
	},
	"connection-requests": {
		"title": "Forespørsler om tilkobling",
		"view-all": "Se alle forespørsler"
	},
	"telephone": "Telefon",
	"import-care-recipient": "Importer omsorgsmottaker",
	"enter-the-care-recipients-unique-username-to-send-an-import-request-to-the-account-owner": "Skriv inn omsorgsmottakerens unike brukernavn for å sende en importforespørsel til kontoeieren.",
	"request-sent": "Forespørsel sendt",
	"request-has-been-sent-to-the-care-receiver-guardian": "Søknad er sendt til omsorgsmottakers foresatte",
	"add-new": "Legg til ny",
	"create-new-care-recipient": "Opprett ny omsorgsmottaker",
	"new-post": "Nytt innlegg",
	"edit-organization": "Rediger organisasjon",
	"temporary-access": {
		"title": "Midlertidig tilgang",
		"send-invite": "Send invitasjon",
		"label-access-duration": "Tilgangsvarighet",
		"label-custom-duration": "Varighet",
		"placeholder-select-care-recipients": "Velg Omsorgsmottakere",
		"label-select-care-recipients": "Utvalgte omsorgsmottakere",
		"new-button": "Ny midlertidig tilgang"
	},
	"roles": {
		"manager": "Systemansvarlig",
		"member": "Omsorgsperson",
		"care-recipient": "Omsorgsmottaker",
		"team-admin": "Team Admin"
	},
	"allow-care-recipient-to-use-pletly": "La Care-mottaker bruke Pletly",
	"family-caregiver-connections-modal": {
		"title": "Familieomsorgsforbindelser",
		"button-disconnect": "Frakople",
		"confirm-disconnect": {
			"title": "Koble fra familieomsorgspersonen",
			"content": "Er du sikker på at du vil koble fra {{caregiverName}} og {{careRecipientName}}?"
		},
		"connections-list-empty": "Tilkoblingslisten er tom"
	},
	"request-ownership": "Be om eierskap",
	"no-email": "Ingen e -post",
	"initial-password-for-first-login": "Opprinnelig passord for første pålogging"
}
